<template>
  <BreadCrumb PageTitle="Formulaire de Recensement" />
  <RecensementForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import RecensementForm from "@/pages/RecensementForm.vue";

export default defineComponent({
  name: "RecensementFormPage",
  components: {
    BreadCrumb,
    RecensementForm,
  },
});
</script>
